<script setup lang="ts">
import Container from 'gpcore-uikit/components/Component.Container.vue';
import Size from 'gpcore-uikit/interfaces/Size';

const { disableContainer = false, contentSize = Size.Large } = defineProps<{
  disableContainer?: boolean;
  contentSize?: Size;
}>();
</script>

<template>
  <div class="tw-ml-0 tw-mt-20 tw-px-4 xl:tw-ml-80 xl:tw-px-8">
    <Container>
      <div v-if="$slots.breadcrumb != null" class="tw-mt-8">
        <slot name="breadcrumb" />
      </div>
      <div v-if="$slots.titlebar != null" class="tw-mt-8">
        <slot name="titlebar" />
      </div>
      <div v-if="$slots.toolbar" class="tw-mb-4 tw-mt-8">
        <slot name="toolbar" />
      </div>
      <div v-if="$slots.tabbar" class="tw-my-8">
        <slot name="tabbar" />
      </div>
    </Container>

    <Container v-if="!disableContainer" :size="contentSize">
      <slot name="content" />
    </Container>

    <template v-else>
      <slot name="content" />
    </template>
  </div>
</template>
